import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { BELGE_TURU } from '../../../../../helpers/sigortaHesap';
import { SigortasizArac, SigortaService } from '../../../../../services/SigortaService';

interface Props {
    show: boolean
    onClose: () => void
}

/**
 * Bugün geçerli poliçesi olmayan aktif araçlar (#501). Araç Sigortası zorunlu trafik sigortasıdır: Treyler (Dorse) /
 * Yarı Römork bu listede yer almaz. Kasko seçilirse bütün aktif araçlar denetlenir.
 */
const SigortasizAraclarModal = ({ show, onClose }: Props) => {
    const [tur, setTur] = useState<number>(BELGE_TURU.TRAFIK);
    const [liste, setListe] = useState<SigortasizArac[] | undefined>(undefined);

    useEffect(() => {
        if (show)
            yukle(tur);
    }, [show, tur])

    const yukle = async (_tur: number) => {
        setListe(undefined);
        try {
            const r = await SigortaService.sigortasizAraclar(_tur);
            if (!r.isSuccess) {
                toast.error(r.message ?? '');
                setListe([]);
                return;
            }
            setListe(r.data as SigortasizArac[]);
        } catch (error: any) {
            toast.error(error);
            setListe([]);
        }
    }

    return (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Sigortasız Araçlar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex gap-2 mb-5">
                    <button className={'btn btn-sm ' + (tur == BELGE_TURU.TRAFIK ? 'btn-primary' : 'btn-light')} onClick={() => setTur(BELGE_TURU.TRAFIK)}>Araç Sigortası</button>
                    <button className={'btn btn-sm ' + (tur == BELGE_TURU.KASKO ? 'btn-primary' : 'btn-light')} onClick={() => setTur(BELGE_TURU.KASKO)}>Kasko Sigortası</button>
                </div>

                <div className="text-muted fs-7 mb-3">
                    {tur == BELGE_TURU.TRAFIK
                        ? 'Bugün geçerli Araç Sigortası (trafik) poliçesi olmayan aktif araçlar. Treyler (Dorse) ve Yarı Römork listelenmez.'
                        : 'Bugün geçerli Kasko poliçesi olmayan aktif araçlar.'}
                </div>

                {
                    liste === undefined ? (
                        <div className="text-center py-10 text-muted">Yükleniyor…</div>
                    ) : liste.length == 0 ? (
                        <div className="text-center py-10 text-success fw-bold">Bütün aktif araçların geçerli poliçesi var.</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table align-middle table-row-dashed ebbe-compact-table">
                                <thead>
                                    <tr className="text-start text-muted fw-bolder text-uppercase">
                                        <th>Plaka</th>
                                        <th>Araç Cinsi</th>
                                        <th>Son Poliçe Bitişi</th>
                                        <th>Sonraki Poliçe Başlangıcı</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-bold">
                                    {
                                        liste.map(a => (
                                            <tr key={a.vehicleId}>
                                                <td>{a.plaka}</td>
                                                <td>{a.aracCinsi}</td>
                                                <td>{a.sonBitis ?? <span className="badge badge-light-danger">Hiç poliçe yok</span>}</td>
                                                <td>{a.sonrakiBaslangic ?? ''}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
                <span className="text-muted fs-7 me-auto">{liste ? `${liste.length} araç` : ''}</span>
                <button className="btn btn-sm btn-light" onClick={onClose}>Kapat</button>
            </Modal.Footer>
        </Modal>
    )
}

export default SigortasizAraclarModal;
